// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.App {
  text-align: center;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.global-home-logo {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1050;
  display: block;
  width: min(28vw, 180px);
  line-height: 0;
  text-decoration: none;
  border-radius: 10px;
  overflow: visible;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.global-home-logo-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
  transition: opacity 0.2s ease;
}

.global-home-logo:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);
}

.global-home-logo:hover .global-home-logo-image,
.global-home-logo:focus-visible .global-home-logo-image {
  opacity: 1;
  filter: invert(1);
}

.global-home-logo:focus-visible {
  outline: 3px solid #5b9bd5;
  outline-offset: 2px;
}

@media (max-width: 600px) {
  .global-home-logo {
    width: min(42vw, 140px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.global-home-logo {\r\n  position: fixed;\r\n  top: 10px;\r\n  left: 10px;\r\n  z-index: 1050;\r\n  display: block;\r\n  width: min(28vw, 180px);\r\n  line-height: 0;\r\n  text-decoration: none;\r\n  border-radius: 10px;\r\n  overflow: visible;\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.global-home-logo-image {\r\n  width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  border-radius: 10px;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.global-home-logo:hover {\r\n  transform: translateY(-2px) scale(1.03);\r\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.global-home-logo:hover .global-home-logo-image,\r\n.global-home-logo:focus-visible .global-home-logo-image {\r\n  opacity: 1;\r\n  filter: invert(1);\r\n}\r\n\r\n.global-home-logo:focus-visible {\n  outline: 3px solid #5b9bd5;\n  outline-offset: 2px;\n}\n\n@media (max-width: 600px) {\n  .global-home-logo {\n    width: min(42vw, 140px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
